const TABLET_BREAKPOINT = 768;

export const VIEWPORT = {
    mobile: "mobile",
    tablet: "tablet",
} as const;

export type DeviceScreenRecommendation =
    | typeof VIEWPORT.mobile
    | typeof VIEWPORT.tablet
    | null;

export type DeviceViewport = {
    width: number;
    height: number;
};

export function getDeviceViewport(): DeviceViewport {
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
}

/**
 * True for phones and tablets that are primarily touch-driven and can be rotated.
 * Excludes typical laptops/desktops (including ones with a touchscreen that still
 * report a fine pointer + hover).
 */
export function isRotatableMobileOrTablet(): boolean {
    return (
        window.matchMedia("(hover: none)").matches
        || window.matchMedia("(pointer: coarse)").matches
    );
}

export function getDeviceScreenRecommendation(
    width: number = getDeviceViewport().width,
    height: number = getDeviceViewport().height,
): DeviceScreenRecommendation {
    if (!isRotatableMobileOrTablet()) {
        return null;
    }

    if (width < TABLET_BREAKPOINT || height < 600) {
        return VIEWPORT.mobile;
    }

    if (height > width && height > TABLET_BREAKPOINT) {
        return VIEWPORT.tablet;
    }

    return null;
}
